<template>
  <div
    class="col-12 col-xl-8 col-xxl-7 mr-auto mx-auto"
    style="
      border: 1px solid #cccccc;
      border-radius: 8px;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
      font-family: IRANSansX-Regular;
      background: #fff;
    "
  >
    <div class="p-3">
      <div
        class="input-group mb-3"
        dir="ltr">
        <input
          v-model="searchTerm"
          dir="rtl"
          type="text"
          class="form-control small"
          placeholder=""
          aria-describedby="button-addon2"
        >
        <button
          id="button-addon2"
          class="btn btn-sm btn-outline-secondary"
          type="button"
          @click="doSearch"
        >
          جستجو
        </button>
      </div>
      <div
        v-if="notes.length != 0"
        class="d-flex flex-row bd-highlight mt-4"
        style="font-size: 14px"
        dir="ltr"
      >
        <div class="bd-highlight">
          <div class="ms-auto bd-highlight">
            <nav aria-label="Chart note navigation">
              <ul class="pagination pagination-sm justify-content-center p-0">
                <li class="page-item">
                  <select
                    v-model="sortField"
                    class="page-link"
                    type="button"
                    @change="getList()"
                  >
                    <option value="save_date">تاریخ</option>
                    <option value="title">عنوان</option>
                  </select>
                </li>
                <li class="page-item">
                  <select
                    v-model="sortOrder"
                    class="page-link"
                    type="button"
                    @change="getList()"
                  >
                    <option
                      value="ASC"
                      style="font-size: 24px">↑</option>
                    <option
                      value="DESC"
                      style="font-size: 24px">↓</option>
                  </select>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div
          class="me-auto"
          style="line-height: 30px; margin-left: 10px">مرتب‌سازی</div>

        <div class="ms-auto bd-highlight">
          <nav aria-label="Chart note navigation">
            <ul class="pagination pagination-sm justify-content-center">
              <li class="page-item">
                <select
                  v-model="perPage"
                  class="page-link"
                  type="button"
                  @change="changePage"
                >
                  <option
                    value="5"
                    selected>5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                </select>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <ol
        v-if="notes.length != 0"
        class="list-group p-0"
        dir="rtl"
        style="min-height: 200px"
      >
        <li
          v-for="item in notes"
          class="list-group-item d-flex justify-content-between align-items-start chart-item"
          @click="openNote(item.chart_id, item.note_id)"
        >
          <div class="ms-auto me-2">
            <div class="fw-bold">
              {{ item.note_title }}
              <small class="text-muted">در چارتِ</small>
              <small class="text-muted">{{ item.title }}</small>
            </div>
            {{ convertToJalali(item.created_at) }}
          </div>
        </li>
      </ol>
      <div
        v-if="notes.length != 0"
        class="d-flex flex-row bd-highlight mt-3"
        dir="ltr">
        <div class="me-auto ms-auto bd-highlight">
          <nav aria-label="Chart note navigation">
            <ul class="pagination pagination-sm justify-content-center">
              <!-- Previous page button -->
              <li
                :class="{ disabled: currentPage === 1 }"
                class="page-item">
                <a
                  class="page-link"
                  href="#"
                  tabindex="-1"
                  aria-disabled="true"
                  @click.prevent="changePage(currentPage - 1)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-left-short"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                    />
                  </svg>
                </a>
              </li>

              <!-- Page numbers -->
              <li
                v-for="pageNumber in displayPages"
                :key="pageNumber"
                :class="{ active: pageNumber === currentPage }"
                class="page-item"
              >
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(pageNumber)">{{
                    pageNumber
                  }}</a>
              </li>

              <!-- Next page button -->
              <li
                :class="{ disabled: currentPage === totalPages }"
                class="page-item">
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(currentPage + 1)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-right-short"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div v-if="notes.length == 0">
        <div
          class="p-3"
          style="
            border: 1px solid #ced4da;
            background-color: #f9f9f9;
            direction: rtl;
            text-align: center;
            border-radius: 8px;
          "
        >
          <p class="mb-4">یادداشت یافت نشد.</p>
          <button
            class="btn btn-outline-danger"
            type="button"
            @click="resetSearch">
            بازگشت
          </button>
        </div>
      </div>
    </div>
    <Loading :is-loading="isLoading" />
  </div>
</template>

<script>
import ApiService from '../service/api'
import moment from 'jalali-moment'
import Loading from '../components/Loading.vue'

export default {
  name: 'MyNoteList',
  components: {
    Loading,
  },
  data () {
    return {
      isLoading: false,
      notes: [],
      searchTerm: '',
      sortField: 'save_date',
      sortOrder: 'DESC',
      perPage: 5,
      currentPage: 1,
      totalNotes: 0,
      editor: [],
      editorData: '',
      editorConfig: {
        toolbar: ['bold', 'italic', '|', 'link'],
        language: {
          ui: 'en',
          content: 'ar'
        }
      }
    }
  },
  computed: {
    totalPages () {
      return Math.ceil(this.totalNotes / this.perPage)
    },
    displayPages () {
      const beforeCurrent = this.currentPage - 1
      const afterCurrent = this.currentPage + 1
      const pages = []

      if (beforeCurrent > 1) {
        pages.push(1)
        if (beforeCurrent > 2) {
          pages.push(null)
        }
      }

      for (let i = beforeCurrent; i <= afterCurrent; i++) {
        if (i > 0 && i <= this.totalPages) {
          pages.push(i)
        }
      }

      if (afterCurrent < this.totalPages) {
        if (afterCurrent < this.totalPages - 1) {
          pages.push(null)
        }
        pages.push(this.totalPages)
      }

      return pages
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    openNote (hash_id, note_id) {
      this.$router.replace({
        name: 'show-note',
        params: { hash_id: hash_id, note_id: note_id }
      })
    },
    resetSearch () {
      this.searchTerm = ''
      this.getList()
    },
    doSearch () {
      this.getList()
    },
    convertToJalali (date) {
      if (date != null) { return moment.from(date, 'en', 'YYYY-MM-DD HH:mm').format('HH:mm jYYYY-jMM-jDD') }
    },
    getList () {
      const params = {
        perPage: this.perPage,
        pageNumber: this.pageNumber,
        searchTerm: this.searchTerm,
        sortOrder: this.sortOrder,
        sortField: this.sortField,
        currentPage: this.currentPage
      }
      // alert('test')
      this.isLoading = true
      ApiService.listNote(params).then((response) => {
        // console.log(response);
        this.notes = response['data']['notes']
        this.totalNotes = response['data']['total_notes']
        this.currentPage = response['data']['currentPage']
        this.isLoading = false
      })
    },
    changePerPage (per_page) {
      this.getList()
    },
    changeSortOrder () {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC'
      this.getList()
    },

    searchCharts () {
      this.currentPage = 1
      this.getList()
    },

    changePage (page) {
      // console.log(page)
      this.currentPage = Number(page)
      this.getList()
    }
  }
}
</script>

<style scoped>
.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
<style scoped>
.chart-item:hover {
  background: #f9f9f9;
  cursor: pointer;
}

.note-title {
  font-size: 14px;
}
</style>
